/*
	Страницы «не найдено»: глобальная — для адресов вне компании, и страница компании — для
	адресов внутри /c/:companyId, чтобы она открывалась в раскладке компании, с её меню.

	Роуты регистрирует приложение, а не общая таблица роутов в src/config/router/routerConfig.js:
	страницы — код приложения ontrack, а общий слой из @ontrack не импортирует.

	Регистрировать нужно до подключения роутера к приложению: при подключении роутер разбирает
	стартовый адрес, и роут, добавленный позже, к этому разбору уже не успеет.
*/

export const NOT_FOUND_ROUTE_NAMES = {
	GLOBAL: 'NotFoundPage',
	COMPANY: 'CompanyNotFoundPage',
}

// Роут компании из общей таблицы: страница компании становится его дочерним роутом
const COMPANY_ROUTE_NAME = 'CompanyPage'

/**
 * @description Добавляет в роутер обе страницы «не найдено». Роутер ранжирует роуты по
 * точности совпадения, поэтому ловушки срабатывают, только когда не подошёл ни один другой
 * роут, а внутри компании ловушка компании точнее глобальной.
 */
export const registerNotFoundRoutes = (router) => {
	router.addRoute({
		path: '/:pathMatch(.*)*',
		name: NOT_FOUND_ROUTE_NAMES.GLOBAL,
		component: () => import('@ontrack/views/NotFoundView.vue'),
	})

	router.addRoute(COMPANY_ROUTE_NAME, {
		path: ':pathMatch(.*)*',
		name: NOT_FOUND_ROUTE_NAMES.COMPANY,
		component: () => import('@ontrack/views/company/CompanyNotFoundView.vue'),
	})
}
